import { State } from '../@types/state';
import { get, patch, del } from './fetch';

export const getAllStates = async (type: string): Promise<State[]> => {
    return await get(`/states/all?type=${type}`);
};

export const updateState = async (id: number, name: string, parentId?: number): Promise<State> => {
    return await patch(`/states/${id}`, { name, parentId });
};

export const deleteState = async (id: number): Promise<void> => {
    return await del(`/states/${id}`);
};
